import PadraoModel from 'src/core/model/PadraoModel.js'

export default class UsadosbrMarcaModel extends PadraoModel {
  recurso = 'usadosbr/marcas';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Marcas Usadosbr';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
